"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarSelection = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var selectors_1 = require("../redux/selectors");
var sortCarsSlice_1 = require("../redux/slice/sortCarsSlice");
var filterSlice_1 = require("../redux/slice/filterSlice");
var useCarSelection = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_redux_1.useSelector)(selectors_1.filtersSelector), filters = _a.values, _b = _a.state, carCount = _b.carCount, filtersList = _b.filtersList;
    var _c = react_1.default.useState(null), openFilter = _c[0], setOpenFilter = _c[1];
    var _d = react_1.default.useState(false), isSortOpen = _d[0], setIsSortOpen = _d[1];
    var handlers = react_1.default.useMemo(function () { return ({
        handleToggleFilter: function (title) {
            setOpenFilter(function (prev) { return (prev === title ? null : title); });
            setIsSortOpen(false);
        },
        handleToggleSort: function () {
            setIsSortOpen(function (prev) { return !prev; });
            setOpenFilter(null);
        },
        handleFindCars: function () {
            var params = {};
            Object.entries(filters).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value && key in filterSlice_1.filterMapping) {
                    params[filterSlice_1.filterMapping[key]] = value.toString();
                }
            });
            var queryString = new URLSearchParams(params).toString();
            navigate("/cars".concat(queryString ? "?".concat(queryString) : ''));
        },
        handleResetFilters: function () {
            dispatch((0, filterSlice_1.resetFilters)());
            navigate('/cars');
        },
        handleViewModeChange: function (mode) {
            dispatch((0, sortCarsSlice_1.setViewMode)(mode));
        },
    }); }, [dispatch, navigate, filters]);
    return {
        filters: filters,
        carCount: carCount,
        filterList: filtersList,
        openFilter: openFilter,
        isSortOpen: isSortOpen,
        handlers: handlers,
    };
};
exports.useCarSelection = useCarSelection;
